import React, { Component } from 'react'
import { withFileInput } from '../../../utils/form'
import Field from '../../common/FormField'
import CurrentImage from './CurrentImage'
import styles from '../../retailer/Form.module.css'

const StoreRep = ({
  data,
  imageRep,
  onChangeFactory,
  disabled,
  fileName,
  previewUrl,
  handleFileInputChange
}) =>
  <fieldset>
    <Field type="toggle">
      <input
        type="checkbox"
        checked={data.storeRepVisible}
        onChange={onChangeFactory('storeRepVisible')}
        disabled={disabled}
      />
      <i data-swchon-text="ON" data-swchoff-text="OFF" />
      Visibility on Profile
    </Field>
    <Field type="input" name="Representative’s Name">
      <input
        type="text"
        placeholder="Enter the representative’s name (i.e John Doe)"
        value={data.storeRep}
        onChange={onChangeFactory('storeRep')}
        disabled={disabled}
      />
    </Field>
    <Field name="Representative’s Title">
      <label className="note">
        This will appear under the representative’s name.
      </label>
      <div className="row">
        <div className="col col-3">
          <label className="radio">
            <input
              type="radio"
              name="representativeTitleGroup"
              value="jeweler"
              checked={data.storeRepTitle === 'jeweler'}
              onChange={onChangeFactory('storeRepTitle')}
              disabled={disabled}
            />
            <i />Your Jeweler
          </label>
        </div>
        <div className="col col-3">
          <label className="radio">
            <input
              type="radio"
              name="representativeTitleGroup"
              value="jewelryDesigner"
              checked={data.storeRepTitle === 'jewelryDesigner'}
              onChange={onChangeFactory('storeRepTitle')}
              disabled={disabled}
            />
            <i />Your Jewelry Designer
          </label>
        </div>
        <div className="col col-3">
          <label className="radio">
            <input
              type="radio"
              name="representativeTitleGroup"
              value="jewelryExpert"
              checked={data.storeRepTitle === 'jewelryExpert'}
              onChange={onChangeFactory('storeRepTitle')}
              disabled={disabled}
            />
            <i />Your Jewelry Expert
          </label>
        </div>
        <div className="col col-3">
          <label className="radio">
            <input
              type="radio"
              name="representativeTitleGroup"
              value="gemstoneVendor"
              checked={data.storeRepTitle === 'gemstoneVendor'}
              onChange={onChangeFactory('storeRepTitle')}
              disabled={disabled}
            />
            <i />Gemstone Vendor
          </label>
        </div>
      </div>
    </Field>
    <Field
      type="input input-file"
      name="Representative's Photo"
      note="Recommended image dimensions: 400px wide by 400px high, or a 1:1 size ratio."
    >
      <div className="button">
        <input
          type="file"
          accept="image/jpeg, image/png"
          onChange={handleFileInputChange}
          disabled={disabled}
        />
        BROWSE
      </div>
      <input
        type="text"
        placeholder="Upload an image of your representative (optional)"
        value={fileName}
        readOnly
      />
    </Field>
    {previewUrl && (
      <div className={styles.imagePreview}>
        <img src={previewUrl} alt="Preview" />
        <div className={styles.imagePreviewLabel}>New image preview — will be saved on submit</div>
      </div>
    )}
    {!previewUrl && imageRep
      ? <CurrentImage
          path={imageRep.get('path')}
        />
      : null}
  </fieldset>

export default withFileInput(StoreRep)
